import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightOutlined } from '@ant-design/icons';
import LocalAiArt from './illustrations/LocalAiArt';
import { scrollToSection } from '../utils/scrollUtils';

const POINTS = [
  { value: '365', unit: '日', label: '安定稼働' },
  { value: '無制限', unit: '', label: 'AI利用回数' },
  { value: '100', unit: '%', label: 'データ社内保存' },
];

const Hero: React.FC = () => (
  <section className="relative overflow-hidden bg-white">
    {/* 背景：ごく淡いネイビーのグラデーションと格子 */}
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-ink-50 to-white" />
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.55]"
      style={{
        backgroundImage:
          'linear-gradient(#E3EBF3 1px, transparent 1px), linear-gradient(90deg, #E3EBF3 1px, transparent 1px)',
        backgroundSize: '64px 64px',
        maskImage: 'radial-gradient(ellipse 80% 60% at 50% 0%, #000 40%, transparent 100%)',
        WebkitMaskImage: 'radial-gradient(ellipse 80% 60% at 50% 0%, #000 40%, transparent 100%)',
      }}
    />

    <div className="container-content relative">
      <div className="grid items-center gap-12 py-16 lg:grid-cols-[1.05fr_1fr] lg:gap-8 lg:py-24">
        {/* 左：コピー */}
        <div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <a
              href="/monitor.html"
              className="inline-flex items-center gap-2 rounded-pill border border-brand-200 bg-brand-50 px-4 py-1.5 text-small font-bold text-brand-700 transition-colors hover:bg-brand-100"
            >
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-500 opacity-60" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-500" />
              </span>
              30日間無料体験 受付中 ／ クレジットカード不要
            </a>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="text-display mt-6 text-ink-900"
          >
            図表で分かる、
            <br />
            <span className="relative inline-block">
              AI内蔵型
              <span className="absolute inset-x-0 bottom-1 -z-10 h-3 bg-brand-100" />
            </span>
            の会計システム
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.16, ease: [0.16, 1, 0.3, 1] }}
            className="text-lead mt-6 max-w-[34rem] text-body-soft"
          >
            外部接続不要・質問回数無制限。
            <br className="hidden sm:block" />
            データを瞬時に図表化し、すべて社内に保存します。
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.24, ease: [0.16, 1, 0.3, 1] }}
            className="mt-9 flex flex-col gap-3 sm:flex-row"
          >
            <a href="/monitor.html" className="btn btn-lg btn-primary">
              30日間無料でお試し
              <ArrowRightOutlined />
            </a>
            <button onClick={() => scrollToSection('features')} className="btn btn-lg btn-secondary">
              機能を見る
            </button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.32 }}
            className="mt-4 text-small text-body-faint"
          >
            初期費用0円／クレジットカード登録不要
          </motion.p>

          {/* 主要指標 */}
          <motion.dl
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="mt-12 grid max-w-lg grid-cols-3 gap-4 border-t border-line pt-8"
          >
            {POINTS.map((p) => (
              <div key={p.label}>
                <dd className="num text-2xl font-bold text-ink-900 sm:text-3xl">
                  {p.value}
                  <span className="text-lg">{p.unit}</span>
                </dd>
                <dt className="mt-1 text-small text-body-soft">{p.label}</dt>
              </div>
            ))}
          </motion.dl>
        </div>

        {/* 右：メインビジュアル */}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <LocalAiArt className="w-full" />
        </motion.div>
      </div>
    </div>
  </section>
);

export default Hero;
